{
  "adhd_options": {
    "f90_0_predominantly_inattentive_type": "F90.0 Attention-deficit hyperactivity disorder, predominantly inattentive type",
    "f90_1_predominantly_hyperactive_type": "F90.1 Attention-deficit hyperactivity disorder, predominantly hyperactive type",
    "f90_2_combined_type": "F90.2 Attention-deficit hyperactivity disorder, combined type",
    "f90_8_other_type": "F90.8 Attention-deficit hyperactivity disorder, other type",
    "f90_9_unspecified_type": "F90.9 Attention-deficit hyperactivity disorder, unspecified type"
  },
  "autism_options": {
    "f84_0_childhood_autism": "F84.0 Childhood autism",
    "f84_1_atypical_autism": "F84.1 Atypical autism",
    "f84_2_rett_syndrome": "F84.2 Rett syndrome",
    "f84_3_other_childhood_disintegrative_disorder": "F84.3 Other childhood disintegrative disorder",
    "f84_4_overactive_disorder_associated_with_mental_retardation_and_stereotyped_movements": "F84.4 Overactive disorder associated with mental retardation and stereotyped movements",
    "f84_5_asperger_syndrome": "F84.5 Asperger syndrome",
    "f84_8_other_pervasive_developmental_disorders": "F84.8 Other pervasive developmental disorders",
    "f84_9_unspecified_pervasive_developmental_disorder": "F84.9 Unspecified pervasive developmental disorder"
  },
  "depression_options": {
    "f33_0_recurrent_depressive_disorder_current_episode_mild": "F33.0 Recurrent depressive disorder, current episode mild",
    "f33_1_recurrent_depressive_disorder_current_episode_moderate": "F33.1 Recurrent depressive disorder, current episode moderate",
    "f33_2_recurrent_depressive_disorder_current_episode_severe_without_psychotic_symptoms": "F33.2 Recurrent depressive disorder, current episode severe without psychotic symptoms",
    "f33_3_recurrent_depressive_disorder_current_episode_severe_with_psychotic_symptoms": "F33.3 Recurrent depressive disorder, current episode severe with psychotic symptoms",
    "f33_4_recurrent_depressive_disorder_currently_in_remission": "F33.4 Recurrent depressive disorder, currently in remission",
    "f33_8_other_recurrent_depressive_disorders": "F33.8 Other recurrent depressive disorders",
    "f33_9_recurrent_depressive_disorder_unspecified": "F33.9 Recurrent depressive disorder, unspecified"
  },
  "visual_impairment_options": {
    "0_mild_or_no_visual_impairment": "Category 0: Mild or no visual impairment",
    "1_moderate_visual_impairment": "Category 1: Moderate visual impairment",
    "2_severe_visual_impairment": "Category 2: Severe visual impairment",
    "3_blindness": "Category 3: Blindness",
    "4_blindness": "Category 4: Blindness",
    "5_blindness": "Category 5: Blindness"
  },
  "grade_options": {
    "a_plus": "A+",
    "a": "A",
    "b_plus": "B+",
    "b": "B",
    "c_plus": "C+",
    "c": "C",
    "d_plus": "D+",
    "d": "D",
    "e_plus": "E+",
    "e": "E"
  },
  "naplan_options": {
    "exceeding": "Exceeding",
    "strong": "Strong",
    "developing": "Developing",
    "needs_additional_support": "Needs Additional Support"
  },
  "extent_options": {
    "not_at_all": "Not at all",
    "mildly": "Mildly",
    "average": "Average",
    "high_extent": "To a high extent",
    "very_high_extent": "To a very high extent"
  },
  "parent_education_options": {
    "not_stated": "Not Stated",
    "bachelor_degree_or_above": "Bachelor Degree or Above",
    "advanced_diploma_or_diploma": "Advanced Diploma or Diploma",
    "certificate1to4": "Certificate 1 to 4",
    "year_12_or_equivalent": "Year 12 or Equivalent",
    "year_11_or_equivalent": "Year 11 or Equivalent",
    "year_10_or_equivalent": "Year 10 or Equivalent",
    "year_9_or_equivalent_or_below": "Year 9 or Equivalent"
  },
  "parent_occupation_options": {
    "senior_managers_and_professionals": "Senior management in large business organisation, government administration and defence, and qualified professionals",
    "other_managers_and_associate_professionals": "Other business managers, arts/media/sports persons and associate professionals",
    "tradespeople_and_skilled_office_sales_and_service_staff": "Tradespeople, skilled office, sales and service staff",
    "unskilled_labourers_office_sales_and_service_staff": "Machine operators, hospitality staff, assistants, labourers and related workers",
    "unemployed": "Unemployed and pensioners"
  },
  "handedness": {
    "left": "Left",
    "right": "Right",
    "ambidextrous": "Ambidextrous"
  },
  "learning_preference_extent_options": {
    "yes": "Yes",
    "no": "No",
    "both": "Both"
  }
}
